module.exports = __webpack_public_path__ + "media/business.10993219.mp4";